export function getTextWidthInRem(text: string, font: string): number {
  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')
  if (!context) return 0

  context.font = font
  const widthPx = context.measureText(text).width

  const rootStyles = getComputedStyle(document.documentElement)
  const designPixelRaw = rootStyles.getPropertyValue('--design-pixel').trim()

  const temp = document.createElement('div')
  temp.style.width = designPixelRaw
  document.body.appendChild(temp)
  const designPixel = temp.offsetWidth
  document.body.removeChild(temp)

  return widthPx / designPixel
}
